<script lang="ts">
	import { years } from '$lib/domain/freshness';
	import sideline from '$lib/images/sideline.svg?raw';
	import { locale } from '$lib/translations';

	interface Props {
		pastDate: Date;
	}

	let { pastDate }: Props = $props();

	const yearsOld = years(pastDate).old();
</script>

{#if yearsOld >= 5}
	<div class="py-4 pr-4 my-8 font-sans text-sm bg-sage-green flex items-center gap-4 [&>svg]:max-h-32 [&>svg]:-my-8">
		{@html sideline}
		<span>
			{#if $locale === 'en'}
				Hey, this post is vintage content. It dates back more than {yearsOld} years ago: it may contain outdated and inaccurate information.
			{:else if $locale === 'it'}
				Ehi, questo post è un contenuto vintage. Risale a più di {yearsOld} anni fa: può contenere informazioni errate e non attuali.
			{/if}
		</span>
	</div>
{:else if yearsOld >= 10}
	<div class="py-4 pr-4 mb-8 font-sans bg-sage-green flex items-center gap-4 [&>svg]:max-h-32 [&>svg]:-my-8">
		{@html sideline}
		<span>
			{#if $locale === 'en'}
				Hey, this post comes from another geological era. It’s over {yearsOld} years old: it’s likely to contain outdated and inaccurate information.
			{:else if $locale === 'it'}
				Ehi, questo post proviene da un'altra era geologica. Ha più di {yearsOld} anni: è probabile che contenga informazioni errate e non attuali.
			{/if}
		</span>
	</div>
{/if}
